import baseAPI from "@/http";

const router = "api/seloDiagnosticoEvidencias";
import { atualUfDefinition } from "@/helpers/utils";

export const seloDiagnosticoEvidenciasAPI = {
  add: (arquivos) =>
    baseAPI.post(`${router}/adicionar-selo-diagnostico-evidencia`, arquivos),
  atualizar: (resposta) =>
    baseAPI.put(`${router}/atualizar-diagnostico-resposta`, resposta),
  delete: (evidenciaId) => baseAPI.delete(`${router}/${evidenciaId}`),
  download: (evidenciaId) =>
    baseAPI.get(
      `${router}/download-diagnostico-evidencia/${evidenciaId}/${atualUfDefinition.uf}/${atualUfDefinition.isParceiro}/${atualUfDefinition.ambient}`,
      {
        responseType: "blob",
      }
    ),
  getEvidenciaPerguntas53_54_55_56: (municipioId, idsPerguntas) =>
    baseAPI.get(
      `${router}/obter-diagnostico-evidencias-by-municipio/${municipioId}/${atualUfDefinition.uf}/${atualUfDefinition.isParceiro}/${atualUfDefinition.ambient}/${idsPerguntas}`
    ),
};
